import { AccountDetailsQuery, useAccountDetailsQuery } from "types/graphql";

type AccountDetails = AccountDetailsQuery["account"];

export const useAccount = ({ bootstrap }): AccountDetails => {
  const { data } = useAccountDetailsQuery({
    skip: bootstrap.account?.anonymous,
  });

  if (bootstrap.accountInfo && bootstrap.accountInfo.account) {
    return bootstrap.accountInfo.account as AccountDetails;
  }

  return data?.account ?? null;
};
